import { useCallback, useEffect } from 'react';
import { useGridExportRegistryOptional } from './GridExportContext';

/**
 * 그리드를 엑셀 내보내기 레지스트리에 등록하고 포커스 마킹 함수를 반환한다.
 */
export function useRegisterGridExport({
  id,
  label,
  getData,
  getDataColumns,
  joinKeys = [],
  contextValues,
  order = 100,
  enabled = true,
}) {
  const registry = useGridExportRegistryOptional();

  useEffect(() => {
    if (!registry || !enabled || !id) return undefined;
    return registry.register({
      id,
      label,
      getData,
      getDataColumns,
      joinKeys,
      contextValues,
      order,
    });
  }, [
    registry,
    enabled,
    id,
    label,
    getData,
    getDataColumns,
    joinKeys,
    contextValues,
    order,
  ]);

  const markFocused = useCallback(() => {
    if (!registry || !id) return;
    registry.setFocused(id);
  }, [registry, id]);

  return { markFocused, registry };
}

/**
 * 등록된 그리드 영역에서 클릭/포커스 시 활성 그리드로 표시
 */
export function GridExportFocusScope({ gridId, children, style }) {
  const registry = useGridExportRegistryOptional();
  const onMark = useCallback(() => {
    if (registry && gridId) registry.setFocused(gridId);
  }, [registry, gridId]);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0,
        minWidth: 0,
        flex: 1,
        ...style,
      }}
      onMouseDownCapture={onMark}
      onFocusCapture={onMark}
    >
      {children}
    </div>
  );
}
